import React from "react";
import LookupAdmin, { ActiveChip } from "../../components/LookupAdmin";
import StatusChip from "../../components/StatusChip";

/**
 * Administração dos campos personalizados do cliente.
 *
 * Diferente do "Informações adicionais" da ficha (nome e valor livres, sem
 * catálogo), o que se cadastra aqui aparece com o mesmo rótulo e o mesmo
 * tipo no formulário de todo cliente. É o que falta para responder "quantos
 * clientes têm Convênio = Unimed", coisa que um campo livre — onde cada
 * atendente digita o nome do jeito que lembra — não permite.
 */

export const TIPO_LABEL = {
  text: "Texto",
  number: "Número",
  date: "Data",
  boolean: "Sim/Não",
  select: "Lista de opções",
};

const config = {
  title: "Campos Personalizados",
  subtitle:
    "Campos extras que passam a aparecer no cadastro de todo cliente, com o mesmo nome e o mesmo tipo — diferente das informações adicionais da ficha, que são livres.",
  endpoint: "/client-field-definitions",
  labelField: "label",
  fields: [
    { name: "label", label: "Nome do campo", required: true, span: 6 },
    { name: "key", label: "Chave (identifica o campo)", span: 6, placeholder: "gerada a partir do nome" },
    {
      name: "type",
      label: "Tipo",
      type: "select",
      required: true,
      span: 4,
      defaultValue: "text",
      options: [
        { value: "text", label: "Texto" },
        { value: "number", label: "Número" },
        { value: "date", label: "Data" },
        { value: "boolean", label: "Sim/Não" },
        { value: "select", label: "Lista de opções" },
      ],
    },
    {
      name: "options",
      label: "Opções (separadas por vírgula) — só para \"Lista de opções\"",
      span: 8,
      placeholder: "Bronze, Prata, Ouro",
      // O que volta do backend é array; o campo de formulário edita texto.
      // Sem isto, reabrir um registro para editar jogaria o array bruto no
      // TextField.
      fromItem: (valor) => (Array.isArray(valor) ? valor.join(", ") : valor || ""),
    },
    { name: "required", label: "Obrigatório", type: "boolean", defaultValue: false },
    { name: "active", label: "Ativo", type: "boolean", defaultValue: true },
    { name: "order", label: "Ordem de exibição", type: "number", defaultValue: 0, span: 3 },
  ],
  columns: [
    { key: "label", label: "Campo" },
    { key: "key", label: "Chave" },
    {
      key: "type",
      label: "Tipo",
      render: (f) => TIPO_LABEL[f.type] || f.type,
    },
    {
      key: "options",
      label: "Opções",
      render: (f) => (Array.isArray(f.options) && f.options.length ? f.options.join(", ") : "—"),
    },
    {
      key: "required",
      label: "Obrigatório",
      render: (f) => <StatusChip dot tone={f.required ? "warning" : "neutral"} label={f.required ? "Sim" : "Não"} />,
    },
    { key: "active", label: "Status", render: (f) => <ActiveChip active={f.active} /> },
  ],
  emptyDescription:
    "Nenhum campo personalizado ainda. Cadastre um acima — ele passa a aparecer no formulário de cliente e na ficha, para todo mundo.",
};

// A tela reaproveita o campo de "options" como texto (mais simples de
// digitar que montar uma lista), e o backend converte a string separada por
// vírgula para o array que o formulário do cliente usa no <select>. Quem
// edita um registro existente recebe de volta um array — convertê-lo para
// texto na tela de edição é responsabilidade do controller, não desta
// página: ver `normalizarOpcoes` em ClientLookupsController.
const ClientFieldDefinitionsPage = () => <LookupAdmin config={config} />;

export default ClientFieldDefinitionsPage;
